<template lang="html">
  <div class="rules-wrapper-background">
    <div class="rules-wrapper">
      <div @click="navigateBack" class="back">
        <img
          src="@/assets/icons/backArrow2.png"
          style="margin-right: 10px;"
          alt=""
        />
        {{ $t('competitions.tr.backToCompetition')}}
      </div>
      <table>
        <thead>
          <tr>
            <td></td>
            <td>{{ $t('main.documentName') }}</td>
            <td></td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(doc, index) in documents" :key="index">
            <td></td>
            <td>{{ doc.cmd_name }}</td>
            <td v-if="doc.cmd_type !== 'DOC'">
              <a class="link" :href="generatePreviewLink(doc)" target="_blank">
                <div class="icon-wrapper">
                  <img
                    src="@/assets/icons/previewDocument.png"
                    alt="preview icon"
                  />
                </div>
              </a>
            </td>
            <td v-else></td>
            <td>
              <a class="link" :href="generateDownloadLink(doc)">
                <div class="icon-wrapper">
                  <img
                    src="@/assets/icons/downloadDocument.png"
                    alt="preview icon"
                  />
                </div>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { api, baseURL } from '@/api'
export default {
  name: 'CompetitionRules',
  data () {
    return {
      documents: [],
      prevRoute: null
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  activated () {
    this.fetchCompetitionRules()
  },
  methods: {
    navigateBack () {
      if (!this.prevRoute.name) {
        this.$router.push({
          name: 'Competitions',
          params: { lang: this.$i18n.locale }
        })
      } else {
        this.$router.back()
      }
    },
    fetchCompetitionRules () {
      let params = {
        cmp_id: this.$route.params.id
      }
      api
        .fetchCompetitionRules(params)
        .then(res => {
          console.log(res)
          this.documents = res.data.data
        })
        .catch(e => {
          console.log(e)
        })
    },
    generatePreviewLink (doc) {
      return baseURL + `/competitions/documents/${doc.cmd_id}/document`
    },
    generateDownloadLink (doc) {
      return baseURL + `/competitions/documents/${doc.cmd_id}/download`
    }
  },
  watch: {
    '$i18n.locale': {
      handler (newLocale, oldLocale) {
        if (newLocale !== oldLocale) {
          this.fetchCompetitionRules()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.rules-wrapper-background {
  background: #f2f2f2;
  padding-top: 30px;
  padding-bottom: 60px;
  width: 100%;

  .rules-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    max-width: 1600px;
    width: calc(100% - 40px);
    margin: 0 auto;
    background: white;
    padding: 40px 40px;
    box-sizing: border-box;
    justify-content: center;
    position: relative;
    align-items: center;
    justify-content: flex-start;

    .back {
      font-weight: 500;
      font-size: 20px;
      line-height: 25px;
      color: rgba(140, 140, 140, 0.96);
      cursor: pointer;
      text-decoration: none;
      margin-bottom: 50px;
      text-align: left;
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      max-width: 1020px;
    }

    table {
      border: 1px solid #e8e8e8;
      width: 100%;
      max-width: 1020px;
      border-collapse: collapse;
      height: fit-content;

      thead {
        td {
          padding: 5px;
          box-sizing: border-box;
          text-align: left;
          height: 65px;
          border-bottom: 1px solid #e8e8e8;
          font-weight: 800;
          font-size: 15px;
          line-height: 24px;
          letter-spacing: 0.06em;
          color: rgba(160, 160, 160, 0.9);
          text-transform: uppercase;
        }
      }
      tbody {
        tr {
          td {
            padding: 5px;
            box-sizing: border-box;
            text-align: left;
            height: 60px;
            border-bottom: 1px solid #e8e8e8;
            font-weight: 600;
            font-size: 15px;
            line-height: 25px;
            letter-spacing: 0.06em;
            color: #606060;

            .icon-wrapper {
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
            }
          }
        }
        tr:last-child {
          td {
            border-bottom: none;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 1024px) {
  .rules-wrapper-background {
    .rules-wrapper {
      margin: 0px;
      padding: 20px;
      width: 100%;
    }
  }
}
</style>
